import { ScriptService } from 'services/script/script.service'
import { isDomReady } from 'utils/dom'
import { logger } from 'utils/system/logger'

export class Recaptcha {
    public static readonly scriptSource =
        'https://www.google.com/recaptcha/api.js'

    public constructor(private recaptcha: HTMLElement) {
        this.loadRecaptcha().catch((err) => logger('error', err))
    }

    private async loadRecaptcha(): Promise<void> {
        await isDomReady()
        const loadDelay = 2000

        if (this.recaptcha) {
            ScriptService.getInstance()
                .loadScript({
                    name: 'recaptcha',
                    src: Recaptcha.scriptSource,
                    loaded: false
                })
                .then(() => {
                    window.setTimeout(() => {
                        this.onloadCallback()
                    }, loadDelay)
                })
                .catch((error: Error) => console.error(error))
        }
    }

    private onloadCallback() {
        const recaptcha = document.getElementById('g-recaptcha-response')
        if (recaptcha) {
            recaptcha.setAttribute('aria-hidden', 'true')
            recaptcha.setAttribute('aria-label', 'Invalid field')
            recaptcha.setAttribute('aria-readonly', 'true')
        }
    }
}
